export enum INTERVENTION_APPOINTMENT_ACTION_TYPES {
  SET_ERRORS = 'SET_ERRORS',
  VALIDATE_TIMESLOT = 'VALIDATE_TIMESLOT',
}

export const PAGINATION_START_FROM_DAY = 0;
